import React from 'react';
import { Select, ISelectProps } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { useCalendarEventTypeOptions } from '@gik/api/calendar/calendarEventType';

export interface ICalendarEventTypeSelectProps extends ISelectProps<number> {}

/**
 * This is a Select component that populates itself with Calendar Request Type Options
 */
export function CalendarEventTypeSelect({
  className,
  ...otherProps
}: ICalendarEventTypeSelectProps): React.ReactElement {
  const { data: options } = useCalendarEventTypeOptions();
  const bem = bemBlock('calendar-event-type-select');
  return (
    <>
      <Select<number> loading={!options} className={bem(null, null, className)} options={options} {...otherProps} />
    </>
  );
}
